/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */
class ScrollNextDiv {
	constructor() {
		this.btnScrollNextDiv = document.getElementById('btn-next-success-cases');
		if (this.btnScrollNextDiv) {
			//console.log(this.btnScrollNextDiv)
			this.init();
		} else {
			return
		}
	}

	init() {
	    this.btnScrollNextDiv.addEventListener('click', () => {
	        const target = document.querySelector('.wrapper-rest-cases');
	        if (!target) return;
	
	        const offset = 130;
	        const scrollToPosition = target.getBoundingClientRect().top + window.scrollY - offset;
	
	        window.scrollTo({
	            top: scrollToPosition,
	            behavior: 'smooth'
	        });
	    });
	}
}

export default ScrollNextDiv;
